import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 21 21",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 9,
			height: 9,
			fill: "#F25022"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 1,
			width: 9,
			height: 9,
			fill: "#7FBA00"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 11,
			width: 9,
			height: 9,
			fill: "#00A4EF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 11,
			width: 9,
			height: 9,
			fill: "#FFB900"
		})
	]
});
export default SvgMicrosoftLogo;
